import React from "react";
import compassSvg from "../../../assets/images/compass.svg";

export const MapCompass: React.FC = () => {
    return (
        <div
            title="Cardinal Directions"
            style={{
                width: "115px",
                height: "115px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <img
                src={compassSvg}
                alt="Compass"
                style={{
                    width: "100%",
                    height: "100%",
                    filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.2))",
                }}
            />
        </div>
    );
};
